/* Twin Pines theme — front-end behaviour (vanilla JS, no dependencies) */
(function () {
  "use strict";

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var burger = document.querySelector("[data-menu-toggle]");
    var menu = document.getElementById("mobile-menu");
    if (!burger || !menu) return;

    function setOpen(open) {
      menu.classList.toggle("open", open);
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) {
        // Move focus to the first nav link (not the search field, to avoid popping the mobile keyboard)
        var first = menu.querySelector("a");
        if (first) first.focus();
      }
    }

    burger.addEventListener("click", function () {
      setOpen(!menu.classList.contains("open"));
    });

    // Escape closes the menu and returns focus to the toggle
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && menu.classList.contains("open")) {
        setOpen(false);
        burger.focus();
      }
    });
  }

  /* ---------- Primary nav dropdowns ----------
     CSS already opens each panel on :hover and :focus-within, so mouse and keyboard
     work with no JavaScript. This adds the two things CSS cannot do:
       1. Touch devices have no hover, so the first tap on a parent opens its panel
          instead of navigating. Only bound where the pointer genuinely cannot hover.
       2. aria-expanded has to track the real state for screen readers, and Escape
          should close an open panel.                                                  */
  function initPrimaryNav() {
    var parents = [].slice.call(document.querySelectorAll("[data-submenu]"));
    if (!parents.length) return;

    var canHover = window.matchMedia("(hover: hover)").matches;

    function setExpanded(li, open) {
      var trigger = li.querySelector("[data-submenu-trigger]");
      if (trigger) trigger.setAttribute("aria-expanded", open ? "true" : "false");
    }

    function closeAll(except) {
      parents.forEach(function (li) {
        if (li === except) return;
        li.classList.remove("open");
        setExpanded(li, false);
      });
    }

    parents.forEach(function (li) {
      var trigger = li.querySelector("[data-submenu-trigger]");
      if (!trigger) return;

      if (canHover) {
        // Panel visibility is CSS-driven here; just mirror it into aria-expanded.
        li.addEventListener("mouseenter", function () { setExpanded(li, true); });
        li.addEventListener("mouseleave", function () { setExpanded(li, false); });
        li.addEventListener("focusin", function () { setExpanded(li, true); });
        li.addEventListener("focusout", function (e) {
          if (!li.contains(e.relatedTarget)) setExpanded(li, false);
        });
      } else {
        trigger.addEventListener("click", function (e) {
          // First tap opens the group; the parent link is still reachable from the
          // "View all collections" item rendered inside the mobile accordion.
          e.preventDefault();
          var willOpen = !li.classList.contains("open");
          closeAll(li);
          li.classList.toggle("open", willOpen);
          setExpanded(li, willOpen);
        });
      }
    });

    if (!canHover) {
      // A tap anywhere outside the nav dismisses whatever is open.
      document.addEventListener("click", function (e) {
        if (!e.target.closest("[data-submenu]")) closeAll(null);
      });
    }

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var openLi = e.target.closest ? e.target.closest("[data-submenu]") : null;
      closeAll(null);
      // Return focus to the parent link so keyboard users keep their place in the bar.
      if (openLi) {
        var trigger = openLi.querySelector("[data-submenu-trigger]");
        if (trigger) trigger.focus();
      }
    });
  }

  /* ---------- Product: size/variant picker ---------- */
  function initProduct() {
    var form = document.querySelector(".product-form");
    if (!form) return;

    var idInput = form.querySelector('[name="id"]');
    // Only the display price elements (main price + sticky bar). The variant
    // buttons also carry data-price for their own value, so exclude them here —
    // otherwise updating textContent would wipe each button's size label.
    var priceEls = document.querySelectorAll("[data-price]:not([data-variant])");
    var weightEl = document.querySelector("[data-weight]");
    var mainImg = document.querySelector("[data-main-image]");

    form.querySelectorAll("[data-variant]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        form.querySelectorAll("[data-variant]").forEach(function (b) {
          b.classList.remove("active");
          b.setAttribute("aria-pressed", "false");
        });
        btn.classList.add("active");
        btn.setAttribute("aria-pressed", "true");
        if (idInput) idInput.value = btn.dataset.variant;
        if (btn.dataset.price) {
          priceEls.forEach(function (el) { el.textContent = btn.dataset.price; });
        }
        if (weightEl && btn.dataset.weight) weightEl.textContent = btn.dataset.weight;
        var img = btn.dataset.image;
        // Clear srcset before swapping src: with srcset present the browser would
        // keep showing the srcset-selected image and ignore the new src.
        if (mainImg && img) { mainImg.removeAttribute("srcset"); mainImg.src = img; }
      });
    });
  }

  /* ---------- Product: image gallery ---------- */
  function initGallery() {
    var thumbs = document.querySelectorAll("[data-thumb]");
    var mainImg = document.querySelector("[data-main-image]");
    if (!thumbs.length || !mainImg) return;
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        thumbs.forEach(function (x) { x.classList.remove("active"); });
        t.classList.add("active");
        // Clear srcset so the src swap actually takes effect (see initVariants note).
        mainImg.removeAttribute("srcset");
        mainImg.src = t.dataset.thumb;
      });
    });
  }

  /* ---------- Product: description tabs ---------- */
  function initTabs() {
    var tabs = document.querySelectorAll("[data-tab]");
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var id = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.remove("active"); });
        tab.classList.add("active");
        document.querySelectorAll("[data-panel]").forEach(function (p) {
          p.classList.toggle("active", p.dataset.panel === id);
        });
      });
    });
  }

  /* ---------- Product: sticky mobile add-to-cart bar ---------- */
  function initStickyAtc() {
    var bar = document.querySelector("[data-atc-bar]");
    var mainBtn = document.querySelector(".addcart");
    if (!bar || !mainBtn || !("IntersectionObserver" in window)) return;

    var footer = document.querySelector(".site-footer");
    var state = { btnVisible: true, footerVisible: false };

    function refresh() {
      // Reveal only while the real Add-to-cart is off-screen and the footer isn't in view
      var show = !state.btnVisible && !state.footerVisible;
      bar.classList.toggle("show", show);
      bar.setAttribute("aria-hidden", show ? "false" : "true");
      // When hidden the bar is only moved off-screen (not display:none), so mark it
      // inert to keep its submit button out of the Tab order and the a11y tree.
      bar.toggleAttribute("inert", !show);
    }

    new IntersectionObserver(function (entries) {
      state.btnVisible = entries[0].isIntersecting;
      refresh();
    }, { rootMargin: "0px 0px -12px 0px" }).observe(mainBtn);

    if (footer) {
      new IntersectionObserver(function (entries) {
        state.footerVisible = entries[0].isIntersecting;
        refresh();
      }).observe(footer);
    }
  }

  /* ---------- Product: quantity stepper (local input) ---------- */
  document.addEventListener("click", function (e) {
    var step = e.target.closest("[data-qty-step]");
    if (!step) return;
    var wrap = step.closest("[data-qty]");
    var input = wrap ? wrap.querySelector("input") : null;
    if (!input) return;
    var val = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10));
    input.value = val;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---------- Header: predictive search (native Shopify Search Suggest API) ---------- */
  function initPredictiveSearch() {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }

    document.querySelectorAll("[data-predictive-search]").forEach(function (form) {
      var input = form.querySelector("[data-predictive-input]");
      var panel = form.querySelector("[data-predictive-results]");
      if (!input || !panel) return;

      var timer = null;

      function close() {
        if (panel.hidden) return;
        panel.hidden = true;
        panel.innerHTML = "";
        input.setAttribute("aria-expanded", "false");
      }
      function open() {
        panel.hidden = false;
        input.setAttribute("aria-expanded", "true");
      }

      function render(data, query) {
        var r = (data.resources && data.resources.results) || {};
        var products = r.products || [];
        var content = (r.pages || []).concat(r.articles || []);
        var html = "";

        if (products.length) {
          html += '<div class="ps-group"><p class="ps-head">Products</p>';
          products.forEach(function (p) {
            var img = p.featured_image ? p.featured_image.url : (p.image || "");
            html += '<a class="ps-item" role="option" href="' + p.url + '">' +
              (img ? '<img class="ps-thumb" src="' + img + '" alt="" width="44" height="44" loading="lazy">' : '<span class="ps-thumb"></span>') +
              '<span class="ps-title">' + escapeHtml(p.title) + '</span></a>';
          });
          html += '</div>';
        }

        if (content.length) {
          html += '<div class="ps-group"><p class="ps-head">Tips &amp; guides</p>';
          content.forEach(function (c) {
            html += '<a class="ps-item ps-item--text" role="option" href="' + c.url + '">' +
              '<span class="ps-title">' + escapeHtml(c.title) + '</span></a>';
          });
          html += '</div>';
        }

        if (!html) {
          html = '<p class="ps-empty">No matches yet. Press Enter to search everything.</p>';
        } else {
          html += '<a class="ps-all" href="' + form.getAttribute("action") + '?q=' + encodeURIComponent(query) + '">See all results</a>';
        }

        panel.innerHTML = html;
        open();

        // Announce the result count to screen readers via the polite live region
        var status = form.querySelector("[data-predictive-status]");
        if (status) {
          var total = products.length + content.length;
          status.textContent = total
            ? total + " suggestion" + (total === 1 ? "" : "s") + " for “" + query + "”"
            : "No suggestions for “" + query + "”";
        }
      }

      function fetchResults(query) {
        var url = root + "search/suggest.json?q=" + encodeURIComponent(query) +
          "&resources[type]=product,page,article&resources[limit]=5&resources[options][unavailable_products]=last";
        fetch(url, { headers: { "Accept": "application/json" } })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (input.value.trim() !== query) return; // ignore stale responses
            render(data, query);
          })
          .catch(function () { close(); });
      }

      input.addEventListener("input", function () {
        var query = input.value.trim();
        clearTimeout(timer);
        if (query.length < 2) { close(); return; }
        timer = setTimeout(function () { fetchResults(query); }, 200);
      });

      input.addEventListener("focus", function () {
        if (input.value.trim().length >= 2 && panel.innerHTML) open();
      });

      input.addEventListener("keydown", function (e) {
        if (e.key === "Escape") { close(); }
        else if (e.key === "ArrowDown" && !panel.hidden) {
          var first = panel.querySelector(".ps-item, .ps-all");
          if (first) { e.preventDefault(); first.focus(); }
        }
      });

      panel.addEventListener("keydown", function (e) {
        var items = Array.prototype.slice.call(panel.querySelectorAll(".ps-item, .ps-all"));
        var idx = items.indexOf(document.activeElement);
        if (e.key === "ArrowDown") { e.preventDefault(); (items[idx + 1] || items[0]).focus(); }
        else if (e.key === "ArrowUp") { e.preventDefault(); if (idx <= 0) { input.focus(); } else { items[idx - 1].focus(); } }
        else if (e.key === "Escape") { close(); input.focus(); }
      });

      document.addEventListener("click", function (e) {
        if (!form.contains(e.target)) close();
      });
    });
  }

  /* ---------- Cart drawer + AJAX cart (Shopify AJAX API + Section Rendering) ---------- */
  function initCartDrawer() {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
    var drawer = document.querySelector("[data-cart-drawer]");
    var CART_PAGE_SECTION = "main"; // section id of main-cart in templates/cart.json
    var lastFocus = null;

    function onCartPage() { return !!document.querySelector("[data-cart-page]"); }
    function sectionList() { return onCartPage() ? "cart-drawer," + CART_PAGE_SECTION : "cart-drawer"; }

    function openDrawer() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.classList.add("open");
      drawer.setAttribute("aria-hidden", "false");
      document.body.classList.add("cart-open");
      var panel = drawer.querySelector(".cart-drawer__panel");
      if (panel) panel.focus();
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove("open");
      drawer.setAttribute("aria-hidden", "true");
      document.body.classList.remove("cart-open");
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function updateCount(count) {
      document.querySelectorAll(".cart-count").forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? "" : "none";
      });
    }

    function toast(msg) {
      var t = document.querySelector(".cart-toast");
      if (!t) { t = document.createElement("div"); t.className = "cart-toast"; document.body.appendChild(t); }
      t.textContent = msg;
      t.classList.add("show");
      clearTimeout(t._timer);
      t._timer = setTimeout(function () { t.classList.remove("show"); }, 3200);
    }

    // Swap only the inner markup so the drawer's open state and delegated events survive
    function applySections(sections) {
      if (!sections) return;
      var parser = new DOMParser();
      if (sections["cart-drawer"] && drawer) {
        var freshInner = parser.parseFromString(sections["cart-drawer"], "text/html").querySelector("[data-cart-drawer-inner]");
        var liveInner = drawer.querySelector("[data-cart-drawer-inner]");
        if (freshInner && liveInner) {
          liveInner.innerHTML = freshInner.innerHTML;
          updateCount(parseInt(freshInner.getAttribute("data-cart-count"), 10) || 0);
        }
      }
      if (sections[CART_PAGE_SECTION]) {
        var freshPage = parser.parseFromString(sections[CART_PAGE_SECTION], "text/html").querySelector("[data-cart-page]");
        var livePage = document.querySelector("[data-cart-page]");
        if (freshPage && livePage) livePage.innerHTML = freshPage.innerHTML;
      }
    }

    function addToCart(form) {
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : "";
      if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }

      var body = new FormData(form);
      body.append("sections", sectionList());
      body.append("sections_url", window.location.pathname);

      fetch(root + "cart/add.js", { method: "POST", headers: { "Accept": "application/json" }, body: body })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok) { toast(r.data.description || r.data.message || "Could not add to cart."); return; }
          applySections(r.data.sections);
          openDrawer();
        })
        .catch(function () { toast("Something went wrong. Please try again."); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
    }

    // After the cart re-renders, put focus back on a sensible control instead of losing it to <body>
    function restoreFocus(selector) {
      var open = drawer && drawer.classList.contains("open");
      var scope = open ? drawer : document;
      var el = selector ? scope.querySelector(selector) : null;
      if (!el) {
        el = open
          ? drawer.querySelector(".cart-drawer__close")
          : document.querySelector('[data-cart-page] [name="checkout"]');
      }
      if (el && el.focus) el.focus();
    }

    function changeLine(line, quantity, focusSelector) {
      fetch(root + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity, sections: sectionList(), sections_url: window.location.pathname })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) { applySections(data.sections); restoreFocus(focusSelector); })
        .catch(function () { toast("Could not update cart."); });
    }

    // Intercept every add-to-cart form (product page, product cards, cross-sell)
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form || form.tagName !== "FORM") return;
      var action = form.getAttribute("action") || "";
      if (action.indexOf("/cart/add") === -1) return;
      e.preventDefault();
      addToCart(form);
    });

    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-cart-toggle]")) { e.preventDefault(); openDrawer(); return; }
      if (e.target.closest("[data-cart-close]")) { e.preventDefault(); closeDrawer(); return; }

      var step = e.target.closest("[data-cart-step]");
      if (step) {
        var item = step.closest("[data-line]");
        if (!item) return;
        var current = parseInt(item.dataset.qty, 10);
        var next = Math.max(0, current + parseInt(step.dataset.cartStep, 10));
        var line = parseInt(item.dataset.line, 10);
        // If the item survives, refocus the same stepper; if it hits zero it's removed, so fall back
        var focusSel = next > 0 ? '[data-line="' + line + '"] [data-cart-step="' + step.dataset.cartStep + '"]' : null;
        changeLine(line, next, focusSel);
        return;
      }
      var rm = e.target.closest("[data-cart-remove]");
      if (rm) {
        var it = rm.closest("[data-line]");
        if (it) changeLine(parseInt(it.dataset.line, 10), 0);
      }
    });

    // Escape closes; keep Tab focus inside the open drawer
    document.addEventListener("keydown", function (e) {
      if (!drawer || !drawer.classList.contains("open")) return;
      if (e.key === "Escape") { closeDrawer(); return; }
      if (e.key === "Tab") {
        var f = drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---------- Collection filters (auto-apply, no reload) ---------- */
  function initCollectionFilters() {
    var form = document.getElementById("collection-filter-form");
    var results = document.getElementById("collection-results");
    var layout = document.querySelector(".layout");
    if (!form || !results || !layout) return;

    // Signals to CSS that the manual "Apply"/"Sort" buttons can be hidden
    layout.classList.add("filters-enhanced");

    var priceTimer = null;
    var reqToken = 0; // guards against a slow response overwriting a newer one

    // Build the collection URL from the form, dropping empty values (e.g. blank price boxes)
    function currentUrl() {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) {
        if (value !== "" && value != null) params.append(key, value);
      });
      var qs = params.toString();
      return window.location.pathname + (qs ? "?" + qs : "");
    }

    function announce() {
      var status = document.querySelector("[data-filters-status]");
      var res = results.querySelector(".res");
      if (status && res) status.textContent = res.textContent.trim();
    }

    function setBusy(state) {
      results.setAttribute("aria-busy", state ? "true" : "false");
    }

    // Fetch the target URL and swap in the new filter sidebar + results
    function render(url, push) {
      var token = ++reqToken;
      setBusy(true);
      fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (token !== reqToken) return; // superseded by a newer request
          var doc = new DOMParser().parseFromString(html, "text/html");
          var newResults = doc.getElementById("collection-results");
          var newFilters = doc.getElementById("collection-filters");
          var curFilters = document.getElementById("collection-filters");
          if (newResults) results.innerHTML = newResults.innerHTML;
          if (newFilters && curFilters) curFilters.innerHTML = newFilters.innerHTML;
          if (push) history.pushState({ collectionFilter: true }, "", url);
          announce();
        })
        .catch(function () {
          if (token === reqToken) window.location.href = url; // fall back to normal navigation
        })
        .then(function () {
          if (token === reqToken) setBusy(false);
        });
    }

    function apply() { render(currentUrl(), true); }

    // Checkboxes and the sort dropdown apply the moment they change
    layout.addEventListener("change", function (e) {
      var t = e.target;
      if (t.matches('input[type="checkbox"]') || t.matches('select[name="sort_by"]')) apply();
    });

    // Price boxes apply shortly after the customer stops typing
    layout.addEventListener("input", function (e) {
      if (!e.target.matches('input[type="number"]')) return;
      clearTimeout(priceTimer);
      priceTimer = setTimeout(apply, 500);
    });

    // Pressing Enter in a price box (or the no-JS Apply button) applies immediately
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      clearTimeout(priceTimer);
      apply();
    });

    // Keep the back/forward buttons in sync with what's on screen
    window.addEventListener("popstate", function () {
      render(window.location.pathname + window.location.search, false);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initMobileMenu();
    initPrimaryNav();
    initProduct();
    initGallery();
    initTabs();
    initStickyAtc();
    initPredictiveSearch();
    initCartDrawer();
    initCollectionFilters();
  });
})();
